import { render } from "./FirstUserPassword.vue?vue&type=template&id=7398813c&scoped=true"
import script from "./FirstUserPassword.vue?vue&type=script&lang=js"
export * from "./FirstUserPassword.vue?vue&type=script&lang=js"

import "@/styles/FirstUserPassword.css?vue&type=style&index=0&id=7398813c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7398813c"]])

export default __exports__